type Translate = (key: string, vars?: Record<string, string | number>) => string;

export function subjectText(
  t: Translate,
  slug: string | null | undefined,
  field: 'name' | 'level' | 'tagline' | 'description',
  fallback: string,
): string {
  if (!slug) return fallback;
  const key = `subject.${slug}.${field}`;
  const value = t(key);
  return value === key ? fallback : value;
}

export function subjectName(t: Translate, subject: { slug: string; name: string }): string {
  return subjectText(t, subject.slug, 'name', subject.name);
}
